import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {
  moveSignatureAction,
  moveSignaturePositionAction,
} from '../../../store/data/signatures/signaturesActions';
import {getSignatures} from '../../../store/data/signatures/signaturesSelectors';
import {SignaturesTableRow} from './signaturesTableRow';

interface SignaturesTableRowContainerProps {
  signatureId: number;
  signatureIndex: number;
}

/*
 * Selectors.
 */

function getSignatureId(_state: AppState, props: SignaturesTableRowContainerProps) {
  return props.signatureId;
}

function getClientSortOrder(_state: AppState, props: SignaturesTableRowContainerProps) {
  return props.signatureIndex + 1;
}

function makeGetSignature() {
  return createSelector(
    [getSignatureId, getSignatures],
    (signatureId, signatures) => signatures[signatureId],
  );
}

const mapStateToProps = makeMapStateToProps<SignaturesTableRowContainerProps>()(() => ({
  signature: makeGetSignature(),
  clientSortOrder: getClientSortOrder,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  moveSignature: moveSignatureAction,
  moveSignaturePosition: moveSignaturePositionAction,
}));

export const SignaturesTableRowContainer = connect(mapStateToProps, mapDispatchToProps)(SignaturesTableRow);
